$('.c-slider').slick({
    responsive: [
        {
            breakpoint: 992,
            settings: {
                arrows: false,
                dots: false
            }
        }
    ]
});


$('.quotes').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 9000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true
            }
        }
    ]
});


$(window).on('load', function () {
    eqHeightSliderContent();
});
$(window).on('resize', function () {
    eqHeightSliderContent()
});

function eqHeightSliderContent() {

    if (window.matchMedia('(max-width:992px)').matches) {
        if ($('.c-slider').length > 0 || $('.quotes').length > 0 ) {
            $('.c-slider, .quotes').each(function () {
                $(this).find('.c-slider__content').css('min-height', '0');
                var maxHeight;
                var heights = $(this).find('.c-slider__content').map(function () {
                    return $(this).height();
                }).get();
                maxHeight = Math.max.apply(null, heights);
                $(this).find('.c-slider__content').css('min-height', maxHeight + 'px');
            })
        }
    }
}